var sound_control_default = {
  "root": "_0VOZZ",
  "sliderContainer": "EF3lH"
};
export {
  sound_control_default as default
};
//# sourceMappingURL=sound-control-scss.js.map
